/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import { SmtpSettingsModel, ISmtpSettingsModel } from './models/smtpSetting.model';
import axios from 'server';

const { model, array } = types;

export const SmtpSettingsFormStore = model('SmtpSettingsFormStore', {
  settings: array(SmtpSettingsModel),
})
  .views((self) => ({
    get firstSettingsBlock() {
      return self.settings.slice(0, 3);
    },
    get secondSettingsBlock() {
      return self.settings.slice(3);
    },
  }))
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeSettings({ data }: AxiosResponse): ISmtpSettingsModel[] {
      self.settings.replace(data.data);
      return self.settings;
    },
    changeSettingValue(settingKey: string, newValue: string): void {
      const index = self.settings.findIndex(({ key }) => key === settingKey);
      self.settings[index].value = newValue;
    },
  }))
  .actions((self) => ({
    getSettings: flow(function* () {
      const result = yield axios
        .get<ISmtpSettingsModel[]>('settings/smtp')
        .then(self.normalizeSettings)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    putSettings: flow(function* () {
      const result = yield axios
        .put<ISmtpSettingsModel[]>('settings/smtp', { data: self.settings })
        .then(self.normalizeSettings)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));

export type ISmtpSettingsFormStore = Instance<typeof SmtpSettingsFormStore>;
